// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor__textarea {
    outline: 0;
}
.editor__textarea::-moz-placeholder {
    color: rgba(120, 120, 120, 0.5);
}
.editor__textarea::placeholder {
    color: rgba(120, 120, 120, 0.5);
}
`, "",{"version":3,"sources":["webpack://./src/components/dialog/ExpandTextDialog.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;AACA;IACI,+BAA+B;AACnC;AAFA;IACI,+BAA+B;AACnC","sourcesContent":[".editor__textarea {\n    outline: 0;\n}\n.editor__textarea::placeholder {\n    color: rgba(120, 120, 120, 0.5);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
